import router from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ITEM_ACTIVE_STATUS } from '@/utils/constants';

export const CategoryProductCount = ({ classes = '', ...props }) => {
  const [count, setCount] = useState(0);

  const {
    catalogData: { categories, catalog_items, productTags },
    showOutOfStockItem,
  } = useSelector((state) => ({
    catalogData: state.catalogReducer,
    showOutOfStockItem: !state.storeReducer.store?.services?.hide_out_of_stock,
  }));

  useEffect(() => {
    if ([...productTags, ...categories].length) {
      const catId = props?.config?.category_id || router?.query?.cid;
      if (catId) {
        const specificCatalogItem = catalog_items[catId];
        setCount(
          specificCatalogItem?.filter?.(
            (item) =>
              item.is_active === ITEM_ACTIVE_STATUS.ACTIVE &&
              (showOutOfStockItem || !!item?.available)
          )?.length
        );
      }
    }
  }, [categories, productTags, catalog_items]);

  return (
    <div className={`ttc product-count ${classes || ''}`}>
      {count} Product{count === 1 ? '' : 's'}
    </div>
  );
};
